import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import useMyAccountPage from './useMyAccountPage';

export const MyAccountPage = () => {
  const manager = useMyAccountPage();
  return (
    <Layout>
      <h1>My Account</h1>
      <p>Username: {manager.user.userName}</p>
    </Layout>
  );
};
